import {
  SET_SUBSCRIBEDMEMBERS_DATA,
  SET_SUBSCRIBEDMEMBERS_COUNT,
} from "../types/types";

export const setSubscribedUsersData = (value) => {
  return {
    type: SET_SUBSCRIBEDMEMBERS_DATA,
    payload: { data: value },
  };
};
export const setSubscribedUsersCount = (value) => {
  return {
    type: SET_SUBSCRIBEDMEMBERS_COUNT,
    payload: { data: value },
  };
};
